<template>
  <div class="col-12">
    <shortcut-card
      v-if="isAugmented ? section.shortcutState !== 'none' : section.hasShortcut"
      :is-current="section.shortcutState === 'current'"
      :no-shortcut="noShortcut"
      :is-mandatory="section.fork ? section.fork.isMandatory : false"
      :shortcut-used="section.shortcutState === 'taken'"
      :is-locked="section.shortcutState !== 'current' && section.modules[0].isLocked ? true : false"
    />
    <fork
      v-if="section.showFork && section.fork"
      v-bind:fork="section.fork"
      :answerFork="answerFork"
      :phaseId="section.id"
      :trans-target="section.fork.isMandatory ? 'augmented_master' : 'new_dashboard'"
    />

    <div v-for="module in section.modules" :key="module.id">
      <module-container
        :module="module"
        :open="
          module.state === 'current' || module.state === 'locked' || module.state === 'waiting'
        "
      >
        <sequential-module
          v-if="module.type === 'sequential'"
          :chapters="module.chapters"
          :key="module.id"
        />
        <compact-module
          v-if="module.type !== 'sequential'"
          :introduction="module.introduction"
          :competences="module.competences"
          :missions="module.missions"
          :key="module.id"
          :type="module.type"
        />
      </module-container>
    </div>
  </div>
</template>

<script>
import CompactModule from "./CompactModule";
import SequentialModule from "./SequentialModule";
import OptionalModule from "./OptionalModule";
import ModuleContainer from "./ModuleContainer";
import ShortcutCard from "./master-dashboard/ShortcutCard";
import Fork from "./Fork";

export default {
  components: {
    ModuleContainer,
    CompactModule,
    SequentialModule,
    ShortcutCard,
    Fork,
    OptionalModule,
  },
  props: {
    section: Object,
    answerFork: Function,
    answerShortcut: Function,
    isAugmented: Boolean,
  },
  methods: {
    noShortcut() {
      this.$emit("loading", true);
      this.answerShortcut(this.section.id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .card {
  cursor: pointer;
  border-radius: 0.5rem;

  .card-body {
    padding: 1.4rem;
  }
}
</style>
